import { useEffect, useState } from 'react';

const WHATSAPP_NUMBER = '2250555199218';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export default function WhatsAppFAB() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2 transition-all duration-700 ease-out ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}
    >
      {/* Tooltip */}
      <div
        className={`bg-foreground-900 text-background-50 text-xs font-semibold px-3 py-2 rounded-lg shadow-lg whitespace-nowrap transition-all duration-300 ${
          isHovered ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0 pointer-events-none'
        }`}
      >
        Discuter sur WhatsApp
        <div className="absolute -bottom-1 right-5 w-2 h-2 bg-foreground-900 rotate-45"></div>
      </div>

      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Discuter sur WhatsApp"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-xl cursor-pointer transition-transform duration-300 ease-out hover:scale-110 hover:shadow-2xl"
        style={{
          transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
        }}
      >
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
        <span className="absolute -inset-1 rounded-full bg-[#25D366]/10 animate-pulse"></span>

        <i className="ri-whatsapp-fill text-white text-2xl relative z-10"></i>
      </a>
    </div>
  );
}